import styled from "@emotion/styled";

const BaseCard = styled("div")`
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const BaseSkeleton = styled("div")`
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 100px;
`;

// Small Card Components
const SmallCardBase = styled(BaseCard)`
  height: 93px;
  width: 125px;
`;

const SmallTitleSkeleton = styled(BaseSkeleton)`
  width: 68px;
  height: 10px;
`;

const SmallDescriptionSkeleton = styled(BaseSkeleton)`
  width: 88px;
  height: 7px;
`;

// Medium Card Components
const MediumCardBase = styled(BaseCard)`
  height: 115px;
  width: 160px;
`;

const MediumTitleSkeleton = styled(BaseSkeleton)`
  width: 88px;
  height: 12px;
`;

const MediumDescriptionSkeleton = styled(BaseSkeleton)`
  width: 114px;
  height: 9px;
`;

// Large Card Components
const LargeCardBase = styled(BaseCard)`
  height: 132px;
  width: 235px;
`;

const LargeTitleSkeleton = styled(BaseSkeleton)`
  width: 127px;
  height: 17px;
`;

const LargeDescriptionSkeleton = styled(BaseSkeleton)`
  width: 165px;
  height: 13px;
`;

export const SmallPurpleCard = styled(SmallCardBase)`
  background: linear-gradient(
    to bottom,
    rgba(111, 82, 187, 1),
    rgba(79, 54, 145, 1)
  );
`;

export const SmallRedCard = styled(SmallCardBase)`
  background: linear-gradient(
    to bottom,
    rgba(245, 66, 83, 1),
    rgba(174, 0, 18, 1)
  );
`;

export const MediumPurpleCard = styled(MediumCardBase)`
  background: linear-gradient(
    to bottom,
    rgba(111, 82, 187, 1),
    rgba(79, 54, 145, 1)
  );
`;

export const MediumRedCard = styled(MediumCardBase)`
  background: linear-gradient(
    to bottom,
    rgba(245, 66, 83, 1),
    rgba(174, 0, 18, 1)
  );
`;

export const LargeCard = styled(LargeCardBase)`
  background: linear-gradient(
    to bottom,
    rgba(254, 125, 6, 1),
    rgba(235, 99, 0, 1)
  );
`;

export {
  SmallTitleSkeleton,
  SmallDescriptionSkeleton,
  MediumTitleSkeleton,
  MediumDescriptionSkeleton,
  LargeTitleSkeleton,
  LargeDescriptionSkeleton,
};
